//import React, { useEffect, useState } from "react";
import "./BankingPartners.css";
//import callApi from "../../../../utility/apiCaller";

const BankingPartners = () => {
  return (
    <div className="banking-partners-section_kf">
      

      {/* Client Logo */}
      <img
        src="/assets/img/clients_logo.png"
        alt="lock"
        className="client-logos-new"
      />

      {/* <p className="partners-title-kf">RBI registered partners</p> */}
      {/* <div className="partners-grid-kf"> */}
        {/* {lenders.map((lender, index) => (
          <div key={index} className="partner-card-kf">
            <img
              src={lender.banking_partners || lender.logo_image_url}
              alt={lender.name || "Lender Logo"}
              className="partner-logo-kf"
              loading="lazy"
            />
          </div>
        ))} */}
        {/* <img
        src="/assets/img/clients_logo.png"
        alt="lock"
        className="hero-lock-img"
      />
      </div> */}
    </div>
  );
};

export default BankingPartners;